import React,{createContext,useState,useEffect} from "react";
import { CustomNotificationService } from "./CustomNotificationService";

export const NotifyContext = React.createContext({});

const NotifyProvider = ({ children }) => {
  const [toast, setToast] = useState([]);

   function getToastState(errMsg) {
   return errMsg
  }

   function getResponse (sendPayload,selectedNotification,buttonSelected){
   try{
    const sendNotification =  CustomNotificationService.sendNotification(sendPayload,
      selectedNotification, buttonSelected);
      Promise.resolve(sendNotification).then((value) =>{
       setToast(value)  
      },(error)=>{
        setToast(error)
      }
      )
      return sendNotification    
   }catch(error){
   }
  
  }

  return (
    <NotifyContext.Provider
      value={{
        getToastState,
        getResponse,
        toast
      }}
    >
      {children}
    </NotifyContext.Provider>
  );
};

export default NotifyProvider;